import { render, staticRenderFns } from "./AuctionInformation.vue?vue&type=template&id=27730ae8&scoped=true&"
import script from "./AuctionInformation.vue?vue&type=script&lang=js&"
export * from "./AuctionInformation.vue?vue&type=script&lang=js&"
import style0 from "./AuctionInformation.vue?vue&type=style&index=0&id=27730ae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27730ae8",
  null
  
)

export default component.exports